import reportWebVitals from './reportWebVitals'
import { bootstrap } from './app'
import { FindPlanMultistepForm } from './views'
import { translateMeta } from './metaTranslator'
import { setDefaultConsent } from './analytics/ga4'

translateMeta()
bootstrap(FindPlanMultistepForm)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

setDefaultConsent()
